import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {FormTranslateComponent} from './form-translate.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
// import {
//     MatButtonModule, MatCardModule, MatCheckboxModule,
//     MatDatepickerModule, MatDialogModule, MatExpansionModule, MatIconModule,
//     MatInputModule, MatListModule,
//     MatMenuModule,
//     MatNativeDateModule, MatProgressBarModule, MatProgressSpinnerModule,
//     MatSelectModule,
//     MatSlideToggleModule, MatSnackBarModule, MatTableModule, MatTabsModule, MatTooltipModule
// } from '@angular/material';

// import {
//     MatButtonModule, MatCardModule, MatCheckboxModule,
//     MatDatepickerModule, MatDialogModule, MatExpansionModule, MatIconModule,
//     MatInputModule, MatListModule,
//     MatMenuModule,
//     MatNativeDateModule, MatProgressBarModule, MatProgressSpinnerModule,
//     MatSelectModule,
//     MatSlideToggleModule, MatSnackBarModule, MatTableModule, MatTabsModule, MatTooltipModule
// } from '@angular/material';
// import {
//     MatButtonModule, MatCardModule, MatCheckboxModule,
//     MatDatepickerModule, MatDialogModule, MatExpansionModule, MatIconModule,
//     MatInputModule, MatListModule,
//     MatMenuModule,
//     MatNativeDateModule, MatProgressBarModule, MatProgressSpinnerModule,
//     MatSelectModule,
//     MatSlideToggleModule, MatSnackBarModule, MatTableModule, MatTabsModule, MatTooltipModule
// } from '@angular/material';
import {SnackBarComponent} from 'dhwani-material-library';
import {ConsentTranslateDialogComponent} from '../shared/consent-translate-dialog/consent-translate-dialog.component';
// import {NgxEditorModule} from 'ngx-editor/public_api';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxEditorModule } from 'ngx-editor';
// import { NgxEditorModule } from 'ngx-editor';

export const TranslateRoues: Routes = [
    {
        path: '',
        component: FormTranslateComponent,
    }
];

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSelectModule,
        MatMenuModule,
        MatSlideToggleModule,
        MatButtonModule,
        MatDialogModule,
        MatSnackBarModule,
        MatCardModule,
        MatIconModule,
        MatListModule,
        MatExpansionModule,
        MatProgressBarModule,
        MatTabsModule,
        MatTableModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        CommonModule,

        RouterModule.forChild(TranslateRoues),
        NgxEditorModule,
    ],
    declarations: [FormTranslateComponent],
    entryComponents: [SnackBarComponent, ConsentTranslateDialogComponent]
})
export class FormTranslateModule {
}
